'use client';

import { useSalesSummaryContext } from './SalesSummaryContext';
import CustomTimeRange from '@/components/filters/CustomTimeRange';
import RestaurantSelection from '@/components/filters/RestaurantSelection';
import { DateSelect } from '@/components/core/forms/DateSelect';
import { Filter, FilterRow } from '@/components/filters/FilterRow';

export default function Filters() {
  const { setTimespan, setTimes, timespan, times } = useSalesSummaryContext();

  return (
    <FilterRow>
      <Filter>
        <RestaurantSelection />
      </Filter>
      <Filter>
        <DateSelect onChange={setTimespan} timespan={timespan} />
      </Filter>
      <Filter>
        <CustomTimeRange times={times} setTimes={setTimes} />
      </Filter>
    </FilterRow>
  );
}
